import { useLocale } from "@calcom/lib/hooks/useLocale";
import type { AppFrontendPayload as App } from "@calcom/types/App";

import { AppCard } from "./AppCard";
import { Slider } from "./Slider";

const POPULAR_SLUGS = ["supportly", "salesforce", "hubspot"];

export const PopularAppsSlider = <T extends App>({ items }: { items: T[] }) => {
  const { t } = useLocale();

  const sorted = [...items].sort((a, b) => {
    const aIdx = POPULAR_SLUGS.indexOf(a.slug);
    const bIdx = POPULAR_SLUGS.indexOf(b.slug);
    if (aIdx !== -1 && bIdx !== -1) return aIdx - bIdx;
    if (aIdx !== -1) return -1;
    if (bIdx !== -1) return 1;
    return (b.installCount || 0) - (a.installCount || 0);
  });

  return (
    <Slider<T>
      title={t("most_popular")}
      items={sorted}
      itemKey={(app) => app.name}
      options={{
        perView: 3,
        breakpoints: {
          768: {
            perView: 1,
          },
        },
      }}
      renderItem={(app) => <AppCard app={app} />}
    />
  );
};
